import { render, staticRenderFns } from "./PaginationFooter.vue?vue&type=template&id=47f0470a"
import script from "./PaginationFooter.vue?vue&type=script&lang=js"
export * from "./PaginationFooter.vue?vue&type=script&lang=js"
import style0 from "./PaginationFooter.vue?vue&type=style&index=0&id=47f0470a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports